import { getSize, getBreakpointValue } from '@mantine/styles';
function getSortedBreakpoints(breakpoints, theme) {
  if (!breakpoints) {
    return [];
  }
  var values = Object.keys(breakpoints).filter(function (breakpoint) {
    return breakpoint !== "base";
  }).map(function (breakpoint) {
    return [getSize({
      size: breakpoint,
      sizes: theme.breakpoints,
      units: "em"
    }), breakpoints[breakpoint]];
  });
  values.sort(function (a, b) {
    return getBreakpointValue(a[0]) - getBreakpointValue(b[0]);
  });
  return values;
}
export { getSortedBreakpoints };